import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
 
function CribScoreCreate() {
  const { t } = useTranslate(); 

  return (
    <Box sx={{ padding: "20px", width: "100%" }}>
      <Grid container spacing={2}>
        <Grid md={6} xs={6} container direction={"column"} spacing={3}>
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.date-time")}</ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6}>
              <ByzMuiDateTimePicker sx={{ width: "300px" }} />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.recording-user")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTextField
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.recording-user")}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography
              sx={{ display: "flex", textAlign: "center" }}
            >
              {t("crib-score.score-calculation")}
            </ByzMuiTypography>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.birth-weight")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("crib-score.birth-weight")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.select")}
                placeholder={t("crib-score.select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.birth-week")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("crib-score.birth-week")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.select")}
                placeholder={t("crib-score.select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.congenital-malformation")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("crib-score.congenital-malformation")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.select")}
                placeholder={t("crib-score.select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.highest-base-deficit-first-12-hours")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("crib-score.highest-base-deficit-first-12-hours")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.select")}
                placeholder={t("crib-score.select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.lowest-appropriate-fio2-first-12-hours")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("crib-score.lowest-appropriate-fio2-first-12-hours")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.select")}
                placeholder={t("crib-score.select")}
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.highest-fio2-first-12-hours")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiSelect
                renderInput={(params) => (
                  <ByzMuiTextField
                    {...params}
                    label={t("crib-score.highest-fio2-first-12-hours")}
                    variant="outlined"
                  />
                )}
                options={[]}
                sx={{ width: "300px" }}
                color="info"
                label={t("crib-score.select")}
                placeholder={t("crib-score.select")}
              />
            </Grid>
          </Grid>

          <Grid sm={6} md={6} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography
              sx={{ display: "flex", textAlign: "center" }}
            >
              {t("crib-score.other")}
            </ByzMuiTypography>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.score")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTextField
                id="outlined-basic"
                label={t("crib-score.score")}
                variant="outlined"
                sx={{ width: "300px" }}
                disabled
              />
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <ByzMuiTypography>{t("crib-score.note")}</ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTextField
                id="outlined-basic"
                label={t("crib-score.note")}
                variant="outlined"
                sx={{ width: "300px" }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CribScoreCreate;